import { IApplicationState } from '../../types/redux';

export const selectHasMortgageDisclaimer = (state: IApplicationState): boolean => {
  return state.adBanner.hasMortgageDisclaimer;
};
